import * as React from 'react'

import styles from './CategoryGridHeader.module.scss'
import Container from '../../layout/Container'

interface OwnProps {
    breadcrumbs?: React.ReactNode
}

type Props = OwnProps

const CategoryGridHeader = ({ breadcrumbs }: Props) => (
    <div className={styles.base}>
        <Container>{breadcrumbs}</Container>
    </div>
)

export default CategoryGridHeader
